var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","display":"flex","align-items":"center","justify-content":"center"},style:({minHeight:`calc(100vh - ${_vm.placeNavHeight}px)`  })},[_c('van-overlay',{staticStyle:{"background-color":"rgb(0 0 0 / 0%)"},attrs:{"show":_vm.loading}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","width":"100%","height":"100%"}},[_c('van-loading',{attrs:{"color":"#7d7d7d","type":"spinner"}})],1)]),_c('div',{staticStyle:{"margin":"auto","background-color":"#fff","display":"flex","justify-content":"center","align-items":"center"},style:(_vm.equipment == 'pc'?{
				// width:equipment == 'pc'?'1280px':'100%'
				..._vm.boxStyleOne,
				minHeight:`calc(100vh - ${_vm.placeNavHeight}px)` 
			}:{
				width:'100%',
				minHeight:`calc(100vh - ${_vm.placeNavHeight}px)` 
			})},[_c('iframe',{ref:"iframe",staticStyle:{"min-height":"650px"},style:(_vm.equipment == 'pc'?{
		 		// width:equipment == 'pc'?'1280px':'100%'
		 		..._vm.boxStyleOne,
				minHeight: '650px'
		 	}:{
		 		width:'96%',
				minHeight: '1000px'
		 	}),attrs:{"id":"iframe","src":"/login?iframe=true","frameborder":"0","scrolling":"auto"},on:{"load":_vm.iframeLoad}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }